import {useMemo} from "react";

import find from "lodash/find";

import {useUser} from "@globals/user";
import {LocationType} from "@globals/user/interfaces";

export default function useLocationData(locationId: number): LocationType {
  const {user} = useUser();

  const locationData = useMemo(
    () =>
      find(user?.locations_list, {
        id: Number(locationId),
      })!,
    [locationId]
  );

  return locationData;
}
